<script setup lang="ts">
export type HitFilterKey = 'undecided' | 'all';

// Shared by HitRail (desktop) and the mobile hit-list screen so both ever
// show the same order and default — previously each hand-rolled its own
// pair of buttons, which drifted out of sync (mobile still led with "All
// hits" after the desktop rail was changed to lead with "Undecided").
const FILTERS: { key: HitFilterKey; label: string }[] = [
  { key: 'undecided', label: 'Undecided' },
  { key: 'all', label: 'All hits' },
];

defineProps<{ modelValue: HitFilterKey }>();
defineEmits<{ 'update:modelValue': [HitFilterKey] }>();
</script>

<template>
  <div class="flex gap-1.5">
    <button
      v-for="filter in FILTERS"
      :key="filter.key"
      type="button"
      class="rounded-full px-2.5 py-1 text-[11.5px] font-semibold"
      :class="
        modelValue === filter.key
          ? 'bg-gray-900 text-white'
          : 'border border-gray-300 bg-white text-gray-500 hover:bg-gray-50'
      "
      @click="$emit('update:modelValue', filter.key)"
    >
      {{ filter.label }}
    </button>
  </div>
</template>
